import { writable } from "svelte/store";
class LoginStore {
    constructor() {
        this.isLogin = writable(false);
    }
}
export const login = new LoginStore();
